export default __webpack_public_path__ + "static/media/boxicons.3e906787.svg";